import React from 'react';

import Grin4UInfoSection from '../../sections/Grin4UInfoSection';

const HomeModule = () => (
  <div><Grin4UInfoSection /></div>
);

export default HomeModule;
